// extracted by mini-css-extract-plugin
export var infoItem = "_o7-2";
export var title = "_o7-0";
export var value = "_o7-1";